module.exports = __webpack_public_path__ + "arrow.58a51771.png";